import request from '~/common/utils/request'

export function readAllNotify (userId) {
  return request({
    url: '/notify/read-all-notify',
    method: 'post',
    data: {
      userId
    }
  })
}
